import ViewProduct from '@/views/product-data/ViewProduct.vue'
import ViewProductCategories from '@/views/product-data/ViewProductCategories.vue'
import ViewProductCategory from '@/views/product-data/ViewProductCategory.vue'
import ViewMasterGroup from '@/views/product-data/ViewMasterGroup.vue'
import ViewProductGroup from '@/views/product-data/ViewProductGroup.vue'
import ViewDocumentApprovals from '@/views/product-data/ViewDocumentApprovals.vue'

export default [
	{
		path: '/product-data/document-approvals',
		name: 'product-data.document-approvals',
		component: ViewDocumentApprovals,
		meta: {
			group: 'product-data'
		}
	},
	{
		path: '/product-data/product-categories',
		name: 'product-data.product-categories',
		component: ViewProductCategories,
		meta: {
			group: 'product-data'
		}
	},
	{
		path: '/product-data/product-categories/:id',
		name: 'product-data.product-category',
		component: ViewProductCategory,
		meta: {
			group: 'product-data'
		}
	},
	{
		path: '/product-data/products/:id',
		name: 'product-data.product',
		component: ViewProduct,
		meta: {
			group: 'product-data'
		}
	},
	{
		path: '/product-data/master-groups/:code',
		name: 'product-data.master-group',
		component: ViewMasterGroup,
		meta: {
			group: 'product-data'
		}
	},
	{
		path: '/product-data/product-groups/:code',
		name: 'product-data.product-group',
		component: ViewProductGroup,
		meta: {
			group: 'product-data'
		}
	}
]
